export default __webpack_public_path__ + "static/performance-7a1e7d934c8ba675500a6ae779e9dec2.png";